module.exports = __webpack_public_path__ + "img/12.bfe103b7.jpg";